// import axios from "axios";
// import dayjs from "dayjs";
// import { saveAs } from "file-saver";
// import _ from "lodash";
// import * as XLSX from "xlsx";

// // import { formatDuration } from "./formatDuration";
// const { REACT_APP_API_MEDIA_LOG_ENDPOINT } = process.env;

// export const handleExportDetails = async ({
//   totalPage,
//   startDate,
//   endDate,
//   deviceId,
//   mediaId,
// }) => {
//   console.log("totalPage :>> ", totalPage);

//   const workbook = XLSX.utils.book_new();
//   const suffixName = dayjs().format("DD-MM-YYYY-HH-mm-ss");
//   const fileName = `details_${suffixName}.xlsx`;

//   for (let page = 1; page <= totalPage; page++) {
//     try {
//       const resp = await axios({
//         method: "post",
//         url: `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/get-details-media-logs`,
//         data: {
//           startDate,
//           endDate,
//           deviceId,
//           mediaId,
//           page: page,
//         },
//       });
//       console.log("page :>> ", page);
//       const respData = _.get(resp, ["data"]);

//       if (_.get(respData, ["status"])) {
//         const results = _.chain(respData).get(["result", "data"]).value();

//         if (!_.isEmpty(results)) {
//           const formattedData = _.map(results, (item) => {
//             const rawStartDate = _.get(item, ["startTime"]);
//             const sDate = dayjs
//               .unix(rawStartDate)
//               .format("DD/MM/YYYY hh:mm:ss");
//             const rawEndDate = _.get(item, ["endTime"]);
//             const eDate = dayjs.unix(rawEndDate).format("DD/MM/YYYY hh:mm:ss");

//             return {
//               "Media Name": _.get(item, ["media_name"]),
//               "Screen Name": _.get(item, ["device_name"]),
//               "Start Date": sDate,
//               "End Date": eDate,
//               duration: _.get(item, ["duration"]),
//             };
//           });

//           const worksheet = XLSX.utils.json_to_sheet(formattedData);
//           worksheet["!cols"] = [
//             { wch: 30 },
//             { wch: 25 },
//             { wch: 20 },
//             { wch: 20 },
//             { wch: 10 },
//           ];

//           XLSX.utils.book_append_sheet(workbook, worksheet, `Page ${page}`);
//         }
//       }
//     } catch (error) {
//       console.error(`Error fetching page ${page}:`, error);
//     }
//   }

//   // 🔹 แปลงและดาวน์โหลดไฟล์ Excel
//   const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//   const file = new Blob([excelBuffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });

//   saveAs(file, fileName);
// };

import axios from "axios";
import dayjs from "dayjs";
import { saveAs } from "file-saver";
import _ from "lodash";
import * as XLSX from "xlsx";

// import { formatDuration } from "./formatDuration";
const { REACT_APP_API_MEDIA_LOG_ENDPOINT } = process.env;

export const handleExportDetails = async ({
  totalPage,
  startDate,
  endDate,
  deviceId,
  mediaId,
  customerList = null,
}) => {
  console.log("เริ่ม Export, จำนวนหน้า:", totalPage);

  const workbook = XLSX.utils.book_new();
  const suffixName = dayjs().format("DD-MM-YYYY-HH-mm-ss");
  const fileName = `details_${suffixName}.xlsx`;

  for (let page = 1; page <= totalPage; page++) {
    try {
      console.log(`กำลังดึงข้อมูลจาก API - หน้า ${page}`);

      const resp = await axios.post(
        `${REACT_APP_API_MEDIA_LOG_ENDPOINT}/get-details-media-logs`,
        {
          startDate,
          endDate,
          deviceId,
          mediaId,
          page,
          customerList,
        }
      );

      const respData = _.get(resp, "data");
      console.log("respData :>> ", respData?.result);
      if (_.get(respData, "status")) {
        const results = _.get(respData, ["result", "data"], []);

        console.log(
          `ดึงข้อมูลสำเร็จ - หน้า ${page}, จำนวน ${results.length} รายการ`
        );

        if (!_.isEmpty(results)) {
          const formattedData = _.map(results, (item) => {
            const rawStartDate = _.get(item, "startTime");
            const rawEndDate = _.get(item, "endTime");

            const sDate = rawStartDate
              ? dayjs.unix(rawStartDate).format("DD/MM/YYYY HH:mm:ss")
              : "N/A";
            const eDate = rawEndDate
              ? dayjs.unix(rawEndDate).format("DD/MM/YYYY HH:mm:ss")
              : "N/A";

            return {
              "Media Name": _.get(item, "media_name", "N/A"),
              "Screen Name": _.get(item, "device_name", "N/A"),
              "Start Date": sDate,
              "End Date": eDate,
              Duration: _.get(item, "duration", "N/A"),
            };
          });

          const worksheet = XLSX.utils.json_to_sheet(formattedData);

          // 🔹 ปรับขนาดคอลัมน์อัตโนมัติ
          worksheet["!cols"] = [
            { wch: 30 }, // Media Name
            { wch: 25 }, // Screen Name
            { wch: 20 }, // Start Date
            { wch: 20 }, // End Date
            { wch: 15 }, // Duration
          ];

          XLSX.utils.book_append_sheet(workbook, worksheet, `Page ${page}`);
        } else {
          console.warn(`⚠️ ไม่มีข้อมูลในหน้า ${page}`);
        }
      }
    } catch (error) {
      console.error(`Error fetching page ${page}:`, error);
    }

    // 🔹 เพิ่ม Delay เพื่อป้องกัน API Block
    await new Promise((resolve) => setTimeout(resolve, 500));
  }

  // 🔹 ถ้าข้อมูลทุกหน้าว่างเปล่า ให้แจ้งเตือน
  if (workbook.SheetNames.length === 0) {
    console.warn("ไม่มีข้อมูลให้ Export");
    return;
  }

  // 🔹 แปลงและดาวน์โหลดไฟล์ Excel
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const file = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(file, fileName);
  console.log(`Export เสร็จสิ้น! ไฟล์ที่ได้: ${fileName}`);
};
